import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { StorageService } from './storage.service';
/*let baseURL = environment.api_url;*/
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { NgxSpinnerService } from 'ngx-spinner';
import { EMPTY } from 'rxjs';
import { environment, Envsetting, Envsetting_local } from '../../../environments/environment';
import { dE } from '@fullcalendar/core/internal-common';
import { API_ENDPOINTS } from '../utils/const';
let baseURL = Envsetting.api_url;
let baseURL_local = Envsetting_local.api_url;
@Injectable({
  providedIn: 'root'
})

export class ApiService {
  loader: any;
  apiURL = Envsetting.api_url;
  token = sessionStorage.getItem('authToken');

  private baseUrl: string = Envsetting.apiBaseUrl;
  //private baseApiUrl: string = 'https://localhost:7015/api/eoiexhibition/EoiExhibitionDownloadZipFile';
  //private baseApiFileUrl: string = 'https://localhost:7015/api/eoiexhibition/DownloadEoiExhibitionFile';

  private baseApiUrl: string = 'https://mssidcapiuat.mahaitgov.in/api/eoiexhibition/EoiExhibitionDownloadZipFile';
  private baseApiFileUrl: string = 'https://mssidcapiuat.mahaitgov.in/api/eoiexhibition/DownloadEoiExhibitionFile';

  constructor(

    private http: HttpClient,
    private ngxUiLoaderService: NgxUiLoaderService,
    private spinnerService: NgxSpinnerService,
    private storageService: StorageService
  ) {
    //this.loader = this.ngxUiLoaderService.getLoaders();
  }

  getRequest(url: string, params?: any, showLoader: boolean = true): Observable<any> {
    params = params ?? {};
    this.token = sessionStorage.getItem('authToken');
    if (showLoader) {
      this.ngxUiLoaderService.start(); // Start loader
    }
    if (params) {
      return this.http
        .get(baseURL + url, {
          params: params,
          headers: {
            //'entity-id': sessionstorage.getitem('entityid') ?? "",
            'Authorization': `Bearer ${this.token}`, // Add the Authorization header
            'Content-Type': 'application/json',  // Ensure content type is JSON

            //added 
            'X-XSS-Protection': '1; mode=block',
            'Content-Security-Policy': 'default-src "self"; script-src "self"; object-src "none";',
            'Referrer-Policy': 'no-referrer-when-downgrade',
            'X-Content-Type-Options': 'nosniff',
            'Permissions-Policy': 'geolocation=(self), microphone=(), camera=()',
            'Strict-Transport-Security': 'max-age=31536000; includeSubDomains; preload'
            //added 
          },
          /*withCredentials: true,*/
        })
        .pipe(
          map((response) => {
            if (showLoader)
              setTimeout(
                () => this.ngxUiLoaderService.stop(),
                500
              );

            return response;
          })
        );
    } else {
      return this.http
        .get(baseURL + url, {
          withCredentials: true,
          headers: {
            //'entity-id': sessionstorage.getitem('entityid') ?? "",
            'Authorization': `Bearer ${this.token}`, // Add the Authorization header
            'Content-Type': 'application/json',  // Ensure content type is JSON
            //added 
            'X-XSS-Protection': '1; mode=block',
            'Content-Security-Policy': 'default-src "self"; script-src "self"; object-src "none";',
            'Referrer-Policy': 'no-referrer-when-downgrade',
            'X-Content-Type-Options': 'nosniff',
            'Permissions-Policy': 'geolocation=(self), microphone=(), camera=()',
            'Strict-Transport-Security': 'max-age=31536000; includeSubDomains; preload'
            //added 
          },
        })
        .pipe(
          map((response) => {
            if (showLoader)
              setTimeout(
                () => this.ngxUiLoaderService.stop(),
                500
              );

            return response;
          })
        );
    }
  }



  postRequest(
    url: string,
    data: any,
    showLoader: boolean = true,
    withCredentials: boolean = true
  ): Observable<any> {
    // Check if entityId, and isPushedToEntity is passed
    /*    data['isNewEntry'] = true;*/
    // Get the token from local storage
        
    if (showLoader) {
      this.ngxUiLoaderService.start(); // Start loader
    }

    return this.http
      .post(baseURL + url, data, {
        //withCredentials: withCredentials
        headers: {
          //'entity-id': sessionstorage.getitem('entityid') ?? "",
          'Authorization': `Bearer ${this.token}`, // Add the Authorization header
          //'Content-Type': 'application/json',  // Ensure content type is JSON
          //added 
          'X-XSS-Protection': '1; mode=block',
          'Content-Security-Policy': 'default-src "self"; script-src "self"; object-src "none";',
          'Referrer-Policy': 'no-referrer-when-downgrade',
          'X-Content-Type-Options': 'nosniff',
          'Permissions-Policy': 'geolocation=(self), microphone=(), camera=()',
          'Strict-Transport-Security': 'max-age=31536000; includeSubDomains; preload'
          //added 
        },
      })
      .pipe(
        map((response) => {
          if (showLoader)
            setTimeout(
              () => this.ngxUiLoaderService.stop(), // Stop loader after request
              1500
            );
          return response;
        }),
        catchError((err, caught) => {
          if (showLoader)
            setTimeout( 
              () => this.ngxUiLoaderService.stop(), // Stop loader after request
              1500
            );

          // return EMPTY;
          return throwError(() => err);
        })
      );
  }

  patchRequest(url: string, data: any, showLoader: boolean = true): Observable<any> {
    if (showLoader)
      setTimeout(
        () => this.ngxUiLoaderService.start(),
        500
      );
    return this.http
      .patch(baseURL + url, data, {
        withCredentials: true,
        headers: {
          'entity-id': sessionStorage.getItem('entityId') ?? "",
          //added 
          'X-XSS-Protection': '1; mode=block',
          'Content-Security-Policy': 'default-src "self"; script-src "self"; object-src "none";',
          'Referrer-Policy': 'no-referrer-when-downgrade',
          'X-Content-Type-Options': 'nosniff',
          'Permissions-Policy': 'geolocation=(self), microphone=(), camera=()',
          'Strict-Transport-Security': 'max-age=31536000; includeSubDomains; preload'
          //added 
        },
      })
      .pipe(
        map((response) => {
          setTimeout(
            () => this.ngxUiLoaderService.stop(),
            500
          );
          return response;
        })
      );
  }

  updateRequest(url: string, data: any,
    showLoader: boolean = true,
    withCredentials: boolean = true): Observable<any> {
    if (showLoader) {
      this.ngxUiLoaderService.start(); // Start loader
    }

    return this.http
      .put(baseURL + url, data, {
        //withCredentials: true,
        headers: {
          //'entity-id': sessionstorage.getitem('entityid') ?? "",
          'Authorization': `Bearer ${this.token}`, // Add the Authorization header
          //added 
          'X-XSS-Protection': '1; mode=block',
          'Content-Security-Policy': 'default-src "self"; script-src "self"; object-src "none";',
          'Referrer-Policy': 'no-referrer-when-downgrade',
          'X-Content-Type-Options': 'nosniff',
          'Permissions-Policy': 'geolocation=(self), microphone=(), camera=()',
          'Strict-Transport-Security': 'max-age=31536000; includeSubDomains; preload'
          //added 
          //'Content-Type': 'application/json'  // Ensure content type is JSON
        },
      })
      .pipe(
        map((response) => {
          setTimeout(
            () => this.ngxUiLoaderService.start(),
            500
          );
          return response;
        })
      );
  }

  deleteRequest(url: string, data?: any): Observable<any> {
    this.ngxUiLoaderService.startLoader(this.loader?.loaderId);
    const userToken = this.storageService.get('token');
    let config = {
      headers: {
        Authorization: 'Bearer ' + userToken,
      },
    };
    return this.http
      .delete(this.apiURL + url, {
        withCredentials: true,
        headers: {
          'entity-id': sessionStorage.getItem('entityId') ?? "",
          //added 
          'X-XSS-Protection': '1; mode=block',
          'Content-Security-Policy': 'default-src "self"; script-src "self"; object-src "none";',
          'Referrer-Policy': 'no-referrer-when-downgrade',
          'X-Content-Type-Options': 'nosniff',
          'Permissions-Policy': 'geolocation=(self), microphone=(), camera=()',
          'Strict-Transport-Security': 'max-age=31536000; includeSubDomains; preload'
          //added 
        },
      })
      .pipe(
        map((response) => {
          setTimeout(() => this.ngxUiLoaderService.stop(),
            500);
          
          return response;
          
        })
      );
    this.ngxUiLoaderService.stop();
  }

  postRequestFile(api_url: any, data: any) {
    this.ngxUiLoaderService.startLoader(this.loader?.loaderId);
    return new Promise((resolve, reject) => {
      // const configForFile = {
      //   headers: {
      //     Authorization:
      //       localStorage.getItem('token') == null
      //         ? ''
      //         : 'Bearer ' + localStorage.getItem('token'),
      //   },
      // };
      this.http
        .post(baseURL + api_url, data, {
          // headers: configForFile.headers,
          responseType: 'arraybuffer',
          withCredentials: true,
          headers: {
            'entity-id': sessionStorage.getItem('entityId') ?? "",
            //added 
            'X-XSS-Protection': '1; mode=block',
            'Content-Security-Policy': 'default-src "self"; script-src "self"; object-src "none";',
            'Referrer-Policy': 'no-referrer-when-downgrade',
            'X-Content-Type-Options': 'nosniff',
            'Permissions-Policy': 'geolocation=(self), microphone=(), camera=()',
            'Strict-Transport-Security': 'max-age=31536000; includeSubDomains; preload'
            //added 
          },
        })
        .subscribe(
          (data): any => {
            this.ngxUiLoaderService.stopLoader(this.loader?.loaderId);
            resolve(data);
          },
          (err) => {
            this.ngxUiLoaderService.stopLoader(this.loader?.loaderId);
            reject(err.error.error);
          }
        );
    });
  }

  getRequestFile(url: string, params?: any): Observable<any> {
    this.ngxUiLoaderService.start();
    //this.spinnerService.show();

    const userToken = localStorage.getItem('token');
    // let config = {
    //   headers: {
    //     Authorization: 'Bearer ' + userToken,
    //   },
    // };

    return this.http
      .get(this.apiURL + url, {
        responseType: 'arraybuffer',
        // headers: config.headers,
        params: params,
        withCredentials: true,
        headers: {
          'entity-id': sessionStorage.getItem('entityId') ?? "",
          //added 
          'X-XSS-Protection': '1; mode=block',
          'Content-Security-Policy': 'default-src "self"; script-src "self"; object-src "none";',
          'Referrer-Policy': 'no-referrer-when-downgrade',
          'X-Content-Type-Options': 'nosniff',
          'Permissions-Policy': 'geolocation=(self), microphone=(), camera=()',
          'Strict-Transport-Security': 'max-age=31536000; includeSubDomains; preload'
          //added 
        },
      })
      .pipe(
        map((response) => {
          //setTimeout(() => this.ngxUiLoaderService.stop(), 500),
            //setTimeout(() => this.spinnerService.hide(), 500);

          return response;
        })
      );
  }


  getIAEventSelectList(userId: any) {

    return this.http
      .get(baseURL_local + '?' + userId)

  }

  getintervention_help(url: string) {
    return this.http.get(baseURL_local + url)
  }


  getComponent_help(id: any, url: string) {
    return this.http.get(baseURL_local + url + id)
  }

  getFund(url: string) {
    return this.http
      .get(baseURL_local + url)
  }

  InsertFund(obj: any, url: string) {
    return this.http
      .post(baseURL_local + url, obj)

  }

  sort<T extends Record<string, any>>(data: T[], sortColumn: string, sortDirection: 'asc' | 'desc'): T[] {
    return data.sort((a, b) => {
      const compareA = a[sortColumn];
      const compareB = b[sortColumn];

      if (sortDirection === 'asc') {
        return compareA < compareB ? -1 : compareA > compareB ? 1 : 0;
      } else {
        return compareA > compareB ? -1 : compareA < compareB ? 1 : 0;
      }
    });
  }

  downloadFile(filePath: string): Observable<Blob> {

    setTimeout(
      () => this.ngxUiLoaderService.start(),
      500
    );

    return this.http.get(`${this.baseUrl}/${filePath}`, {
      responseType: 'arraybuffer',
      observe: 'response'
    }).pipe(
      map((response: HttpResponse<ArrayBuffer>) => {
        setTimeout(
          () => this.ngxUiLoaderService.stop(),
          500
        );
        return new Blob([response.body!], { type: 'application/pdf' }); // Create a Blob from the response body

      })
    );
  }


  downloadFilealltype(filePath: string): Observable<Blob> {

  setTimeout(() => this.ngxUiLoaderService.start(), 500);

  return this.http.get(`${this.baseUrl}/${filePath}`, {
    responseType: 'blob'
  }).pipe(
    tap(() => {
      setTimeout(() => this.ngxUiLoaderService.stop(), 500);
    })
  );
}

  downloadEoiExhibitionZip(fileName: string) {
    return this.http.get(
      `${this.baseApiUrl}?fileName=${fileName}`,
      { responseType: 'blob' }
    );
  }

  downloadEoiExhibitionFile(filePath: string) {
    return this.http.get(
      `${this.baseApiFileUrl}?fileName=${filePath}`,
      { responseType: 'blob' }
    );
  }

  getFilePreview(filePath: string): Observable<string> {
    setTimeout(
      () => this.ngxUiLoaderService.start(),
      500
    );
    return this.http.get(`${this.baseUrl}/${filePath}`, {
      responseType: 'arraybuffer',
      observe: 'response'
    }).pipe(
      map((response: HttpResponse<ArrayBuffer>) => {
        const fileBlob = new Blob([response.body!], { type: this.getFileMimeType(filePath) });
        setTimeout(
          () => this.ngxUiLoaderService.stop(),
          500
        );

        const fileUrl = URL.createObjectURL(fileBlob);

        // Check if the file is a PDF based on MIME type
        if (this.getFileMimeType(filePath) === 'application/pdf') {
          // For PDF, you may want to display it in an iframe or use a PDF viewer
          return fileUrl;
        }

        return URL.createObjectURL(fileBlob);
      })
    );
  }

  private getFileMimeType(filePath: string): string {
    const fileExtension = filePath.split('.').pop()?.toLowerCase();
    if (fileExtension === 'pdf') {
      return 'application/pdf';
    } else if (['jpg', 'jpeg', 'png'].includes(fileExtension!)) {
      return `image/${fileExtension}`;
    } else {
      return 'application/octet-stream';  // fallback for unknown types
    }
  }

  GetDynamicDashboardData(type: string) {

    console.log("Popup loading..........");

    return this.http.get<any>(`${baseURL_local}mssidc/GetDashboardPopupData/${type}`)
      .pipe(
        map((res: any) => {

          const data = res?.namedDataSets || {};   // ✅ FIX KEY PATH

          switch (type) {

            case 'totalIA':
              return data.TotalIAList || [];

            case 'avgTurnoutPerWorkshop':
              return data.AvgTurnoutList || [];

            case 'totalEvents':
              return data.TotalEventsList || [];

            case 'uniqueMSMEBenefitted':
              return data.UniqueMSMEList || [];

            case 'submittedInvoiceCount':
              return data.SubmittedInvoiceList || [];

            case 'scstLed':
              return data.SCSTLedMSMEList || [];

            case 'womenLed':
              return data.WomenLedMSMEList || [];

            case 'msmeFormalised':
              return data.MSMEFormalisedList || [];

            default:
              return [];
          }
        })
      );
  }

}
